import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { shareReplay } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { Language } from '../models';

@Injectable({
    providedIn: 'root'
})
export class LanguagesService {
    languages$ = this._http
        .get<Language[]>(`${environment.apiUrl}/Languages`)
        .pipe(shareReplay(1));

    constructor(private readonly _http: HttpClient) {}
}
